<div class="chart-wrapper">
  <div *ngIf="loading" class="chart-state">Loading…</div>
  <div *ngIf="!loading && !hasData" class="chart-state">
    No data available yet.
  </div>
  <canvas baseChart
    [data]="lineChartData"
    [options]="lineChartOptions"
    [plugins]="lineChartPlugins"
    [type]="lineChartType"
    (chartHover)="chartHovered($event)"
    (chartClick)="chartClicked($event)"
    style="display: block; width: 100%; height: 100%;">
  </canvas>
</div>
